<template>
    <div>
    <list class="m-0 p-0"
          :columns="columns"
          v-model="teams"
          :actionColumnLabel="$t('Select')"
    >
        <template slot="header">
            <div class="col-12 p-0">
                <h4 class="d-inline m-0 p-1">{{ $t('Result selection') }}</h4>
            </div>
            <fg-input class="pt-2 pb-2 btn-one-size-dropdown">
                <el-select size="large"
                           class="select-primary"
                           :placeholder="$t('Time frame')"
                           fullWidth
                           @input="setMonthsFilter"
                           :value="months">
                    <el-option v-for="option in monthsOptions"
                               :value="option.value"
                               :label="$t(option.label)"
                               :key="option.value">
                    </el-option>
                </el-select>
            </fg-input>
        </template>
        <template slot="chartByRow" slot-scope="props">
<!--            <basic-chart :data="props.row.overAllTrend"/>-->
            <div class="row p-0">
                <div class="col-12 col-12 p-0">
                    <component is="line-chart-simple"
                               :labels="props.row.overAllTrend.labels"
                               :height="chartHeight"
                               :data="props.row.overAllTrend.series">
                    </component>
                </div>
                <!-- div class="col-2 col-2 p-0">
                    <status-indicator class="mr-1" :value="props.row.overAllTrend.average" :trend="props.row.overAllTrend.averageTrend" :precision="0"/>
                </!-->
                <!-- div class="col-1 col-1 p-0">
                    <p-button round type="primary" size="sm" icon
                              @click="createTaskAvgClick('', '', props.row.overAllTrend.average)">
                        <i class="fa fa-bullhorn"/>
                    </p-button>
                </!-->
            </div>


        </template>
        <template slot="actionsByRow" slot-scope="props">
            <router-link tag="a" :to="{ name: 'TeamView', params: { qid: $route.params.qid, tid: props.row._id } }">
                <p-button round type="primary" size="sm" icon>
                    <i class="fa fa-arrow-right"/>
                </p-button>
            </router-link>
        </template>

    </list>

        <modal v-model="showDialog" :title="$t('Create Task')" :submit="save" :cancel="cancel" submit-text="Save">
            <template slot="body">
                <fg-input name="taskTitle"
                          :label="$t('Title')"
                          autocomplete="off"
                          :placeholder="$t('Title')"
                          v-model="task.title">
                </fg-input>
                <fg-input :label="$t('Description')">
                    <el-input type="textarea"
                              :placeholder="$t('Description')"
                              :autosize="{ minRows: 3, maxRows: 4}"
                              v-model="task.description"/>
                </fg-input>
                <fg-input :label="$t('Due date')"
                          name="dueDate"
                          v-model="task.dueDate">
                    <el-date-picker v-model="task.dueDate" type="date" placeholder="Pick a date"/>
                </fg-input>
            </template>
        </modal>

    </div>
</template>

<script>
  import { mapActions, mapGetters, mapState } from 'vuex'
  import List from '../../Dashboard/Components/BasicList'
  import { Select, Option, Input, DatePicker } from 'element-ui'
  import BasicChart from '../../Dashboard/Components/BasicChart'
  import LineChartSimple from '../../UIComponents/Charts/LineChartSimple'
  import StatusIndicator from '../../Dashboard/Components/StatusIndicator'
  import Modal from '../../Dashboard/Components/BasicModal'

  export default {
    name: 'TeamSelection',
    components: {
      List,
      [Select.name]: Select,
      [Option.name]: Option,
      [Input.name]: Input,
      [DatePicker.name]: DatePicker,
      BasicChart,
      LineChartSimple,
      StatusIndicator,
      Modal
    },
    data () {
      return {
        sf: 'name',
        so: 'asc',
        columns: [
          { name: 'title', text: 'Teams', sortable: false, align: 'left', minWidth: 150 }
        ],
        chartHeight: 80,
        task: {},
        showDialog: false,
      }
    },

    async mounted () {
      this.init()
    },

    computed: {
      ...mapState('user/teams', {
        months: state => state.months,
        monthsOptions: state => state.monthsOptions,
      }),
      ...mapState('user/teams/teamsByQuestionnaire', {
        questionnaire: state => state.questionnaire
      }),
      ...mapGetters({ getTeams: 'user/teams/teamsByQuestionnaire/getTeams' }),
      teams: function () {
        return this.getTeams(this.$route.params.qid)
      },
      breadcrumb: function () {
        const breadcrumb = []
        if (this.questionnaire) {
          breadcrumb.push({ name: 'TeamQuestionnaires', label: this.$options.filters.languageString(this.questionnaire.title) })
        }
        breadcrumb.push({ name: 'TeamSelection', label: 'Team selection' })
        return breadcrumb
      }
    },

    methods: {
      ...mapActions('user/teams/teamsByQuestionnaire', ['getList']),
      ...mapActions('user/teams', ['setMonthsFilter', 'initPackageMonthsOptions']),
      ...mapActions('user/tasks', ['createTask']),
      async init () {
        this.initPackageMonthsOptions(this.$auth.user.customer.settings.contract.packageType)
        await this.fetchTeams()
      },
      async fetchTeams () {
        await this.getList({ questionnaireId: this.$route.params.qid, sf: 'title', so: 'asc', months: this.months })
      },
      languageFormatter: function (row, column, cellValue) {
        return this.$options.filters.languageString(cellValue)
      },
      dateFormatter: function (row, column, cellValue) {
        return this.$options.filters.formatDate(cellValue)
      },
      createTaskAvgClick (userId, query, value) {
        this.showDialog = true
        this.task = {
          assigneeType: 'user',
          assignee: '5db6a3110ce5383a719c91de',
          dueDate:"2020-01-29T23:00:00.000Z"
        }
      },
      cancel: function () {
        this.showDialog = false
      },
      save: function () {
        const { title, assigneeType, description, assignee, dueDate } = this.task
        const data = { title, assigneeType, description, assignee, dueDate }

        this.createTask({ item: data })
        this.showDialog = false
      },
    },

    watch: {
      breadcrumb () {
        this.$store.commit('breadcrumb/SET_ROUTE_DATA', {
          path: this.$route.path,
          breadcrumb: this.breadcrumb
        }, { root: true })
      },
      months (val) {
        if (val) {
          this.fetchTeams()
        }
      },
      async '$route.params.qid' (val) {
        if (val.length > 1) {
          this.init()
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
    .status-indicator {
        min-width: 25px;
        max-width: 27px;
        height: 26px;
        line-height: 25px;
        margin: 2px 0px;
        border-radius: 10px;
    }

    @media (max-width: 590px) {
        .btn-one-size-dropdown {
            width: 100%;
            padding-left: 0px;
            padding-right: 0px;
            padding-right: 10px !important;
        }
    }

</style>
